/* HAZAR — hz-early.js (سرعة الموبايل 2026-09-08، البند #12)
   كان هالكود مكتوبًا حرفيًا داخل <head> بكل صفحة (HTML عندنا no-store، يعني ينزل من جديد كل مرة).
   صار ملف أصل واحد يُكاش بالمتصفح — بس بنفس المكان و**بدون defer/async**: هالأنظمة بتخبّي عناصر
   بكلاسات يضيفها الجافاسكربت، فلو تأخّرت عن الرسمة الأولى بيبان المحتوى ثم يختفي ثم يظهر (رمشة).
   الترتيب هون هو نفس ترتيبه بالثيم بالضبط: المرسل الموحّد أولًا لأن الباقي بيناديه.
   ═══ 1) المرسل الموحّد hzOnAdded + رسم عيّنات الألوان ═══ */
  /* ===== r59 — المرسل الموحّد لمراقبة DOM =====
     كان عندنا 13 مراقب MutationObserver عريض (childList+subtree على الجذر)
     كل واحد يمسح بنفسه عند كل تغيير — صاروا مراقباً واحداً يصفّ العقد
     المضافة ويوزّعها دفعة واحدة قبل الرسم (rAF يسبق style/layout/paint،
     فكلاسات الإخفاء/الكشف تصل قبل أول إطار — لا وميض). */
  (function(){
    "use strict";
    if (window.hzOnAdded) return;
    var handlers = [], queue = [], scheduled = false;
    function flush(){
      scheduled = false;
      if (!queue.length) return;
      var q = queue; queue = [];
      for (var i = 0; i < q.length; i++){
        var n = q[i];
        if (!n.isConnected) continue;
        for (var h = 0; h < handlers.length; h++){ try { handlers[h](n); } catch(e){} }
      }
    }
    function schedule(){
      if (scheduled) return;
      scheduled = true;
      if (window.requestAnimationFrame){
        window.requestAnimationFrame(flush);
        /* شبكة أمان: التبويبات المخفية لا تشغّل rAF — لا نترك الصف عالقاً */
        setTimeout(function(){ if (scheduled) flush(); }, 300);
      } else { setTimeout(flush, 16); }
    }
    window.hzOnAdded = function(fn){ handlers.push(fn); };
    try {
      new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++){
          var a = muts[i].addedNodes;
          for (var j = 0; j < a.length; j++){ if (a[j].nodeType === 1) queue.push(a[j]); }
        }
        if (queue.length) schedule();
      }).observe(document.documentElement, { childList: true, subtree: true });
      /* documentElement موجود من لحظة تحليل الرأس — يغطي عقد التحليل نفسها */
    } catch(e){}
  })();
  /* HAZAR — الألوان المركبة: تقسيم الدائرة لأجزاء متساوية حسب عدد الألوان (Black/Brown ...) */
  (function(){
    // نفس خريطة الألوان المستخدمة في الـ CSS (الأطول أولاً ليُطابَق قبل الأقصر)
    var MAP = [
      ["d.beige","#c2a878"],["d. beige","#c2a878"],
      ["d.brown","#3e2417"],["d. brown","#3e2417"],
      ["d.camel","#9a7b4f"],["d. camel","#9a7b4f"],
      ["d.gr","#595959"],["d. gr","#595959"],
      ["l.beige","#e8dcc0"],["l. beige","#e8dcc0"],
      ["l.blue","#a7c7e7"],["l. blue","#a7c7e7"],
      ["l.gold","#e6c77e"],["l. gold","#e6c77e"],
      ["l.turabi","#c4b49a"],["l. turabi","#c4b49a"],
      ["platinum","#d6d6d6"],["turabi","#a89478"],["maroon","#800000"],
      ["bronze","#8c7853"],["coffee","#4b3621"],["khaki","#8b7e5a"],
      ["silver","#c0c0c0"],["orange","#e07b39"],["jeans","#5a6f8c"],
      ["beige","#d9c6a5"],["camel","#c19a6b"],["brown","#6b4226"],
      ["black","#1a1a1a"],["white","#ffffff"],["green","#4a5d3a"],
      ["navy","#1f2a44"],["nude","#e3bc9a"],["blue","#2c4a7c"],
      ["gold","#d4af37"],["pink","#e8a0bf"],["gray","#8a8a8a"],
      ["grey","#8a8a8a"],["dark","#333333"],["red","#b11226"],["off","#f2efe4"]
    ];
    function hex(part){
      var s = (part||"").trim().toLowerCase();
      for (var i=0;i<MAP.length;i++){ if (s.indexOf(MAP[i][0])===0) return MAP[i][1]; }
      return null;
    }
    function gradient(name){
      var parts = (name||"").split(/[\/،,]+/).map(function(p){return p.trim();}).filter(Boolean);
      if (parts.length < 2) return null;            // لون واحد → يتركه للـ CSS
      var cols = parts.map(hex);
      if (cols.indexOf(null) !== -1) return null;    // جزء غير معروف → لا نلمسه
      var n = cols.length, stops = [];
      for (var i=0;i<n;i++){
        var a=(i*100/n).toFixed(2), b=((i+1)*100/n).toFixed(2);
        stops.push(cols[i]+" "+a+"% "+b+"%");
      }
      return "conic-gradient(from 0deg, "+stops.join(", ")+")";
    }
    function paint(el, name){
      /* r76: حارس — نفس الدائرة بتتعالج مع كل دفعة تغييرات بالصفحة (الفلاتر/السلايدر/التحميل الكسول)؛ الكتابة المتكرّرة
         لنفس القيمة بتجبر المتصفح يعيد حساب الأنماط عالفاضي. مرّة وحدة لكل (عنصر، اسم). */
      if (el.__hzPaint === name) return;
      el.__hzPaint = name;
      var g = gradient(name);
      if (g) el.style.setProperty("background-image", g, "important");
    }
    function run(root){
      root = root || document;
      // صفحة المنتج
      root.querySelectorAll(".is-style-color input[value]").forEach(function(inp){
        var lab = inp.nextElementSibling;
        var sw = lab && lab.querySelector(".hdt-form-color-pattern");
        if (sw) paint(sw, inp.getAttribute("value"));
      });
      // كروت الأقسام
      root.querySelectorAll("hdt-swatch-card[title]").forEach(function(c){
        paint(c, c.getAttribute("title"));
      });
    }
    if (document.readyState !== "loading") run(); else document.addEventListener("DOMContentLoaded", function(){run();});
    // مراقبة المحتوى المُحمَّل لاحقاً (AJAX، فلترة، تحميل المزيد) — r59: عبر المرسل الموحّد
    window.hzOnAdded(run);
  })();
  

/* ═══ 2) ظهور بطاقات المنتجات بالتمرير ═══ */
  /* HAZAR — ظهور بطاقات المنتجات تدريجياً عند الوصول إليها بالتمرير */
  (function(){
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('hz-in'); io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.04});
    function reveal(root){
      (root||document).querySelectorAll('.hdt-card-product:not(.hz-reveal)').forEach(function(el,i){
        el.classList.add('hz-reveal');
        el.style.transitionDelay = ((i % 4) * 60) + 'ms';   // تتالٍ لطيف حسب أعمدة الشبكة
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function(){reveal();});
    /* r59: المرسل الموحّد (rAF يسبق الرسم — كلاس hz-reveal يصل قبل أول إطار) */
    window.hzOnAdded(reveal);
  })();
  

/* ═══ 3) reveal-extend: ظهور السكاشن + كين-بيرنز + دخول البانرات + الهيدر + الماركي + شارة الإضافة ═══ */
/* ===== reveal-extend ===== */
(function(){
  "use strict";

  // Idempotency: never wire this feature twice (head injection + re-run safety).
  if (window.__hzSectionRevealInit) return;
  window.__hzSectionRevealInit = true;

  var REDUCE = false;
  try {
    REDUCE = window.matchMedia &&
             window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch(e){ REDUCE = false; }

  // Marker that means "this element already belongs to a reveal system"
  // (either the card system .hz-reveal, or ours). Used to skip.
  var REVEAL_MARK = "hz-reveal";          // base class used by cards too
  var FADE = "hz-reveal--fade";           // lighter variant (headings/text)
  var BLOCK = "hz-reveal--block";         // section-level content blocks
  var ARM = "hz-rv-arm";                  // transient will-change hint
  var IN = "hz-in";
  var DONE = "hz-rv-done";                // our own processed marker

  function isReducedSafe(el){
    // In reduced-motion we still "process" so we don't reprocess, but we
    // never hide and never add a variant class. Just mark done.
    el.classList.add(DONE);
  }

  // Decide which variant class an element should get.
  function variantFor(el){
    // Heading containers + headings -> light fade.
    if (el.matches &&
        (el.matches(".hdt-container-heading") ||
         el.tagName === "H2" || el.tagName === "H3")){
      return FADE;
    }
    // Everything else we target is a block.
    return BLOCK;
  }

  // Should we skip this element?
  function shouldSkip(el){
    if (!el || el.nodeType !== 1) return true;
    if (el.classList.contains(DONE)) return true;
    // Already part of any reveal system (cards carry .hz-reveal).
    if (el.classList.contains(REVEAL_MARK)) return true;
    if (el.classList.contains(FADE) || el.classList.contains(BLOCK)) return true;
    if (!el.closest) return true; // very old engine: bail to "no-op visible"
    // Never touch product cards or anything inside one.
    if (el.closest(".hdt-card-product")) return true;
    // Never reveal the hero slideshow or anything inside it (above the fold).
    if (el.closest(".hdt-slideshow")) return true;
    // Don't touch the sticky header / announcement bar chrome.
    if (el.closest(".hdt-section-header")) return true;
    if (el.closest(".hdt-section-announcement-bar")) return true;
    // Avoid revealing the slider track / slide internals if matched indirectly.
    if (el.closest(".hdt-slider")) return true;
    // Banners are owned by the banner-entrance feature (per-item stagger);
    // never touch anything inside a banner wrap from here.
    if (el.closest(".hdt-banner_wrap")) return true;
    return false;
  }

  // Reveal helper: clears any pending stagger + fallback timer, drops the
  // GPU hint, and marks visible. Always safe to call more than once.
  function reveal(node){
    if (node.__hzTo){ clearTimeout(node.__hzTo); node.__hzTo = null; }
    node.classList.remove(ARM);
    node.classList.add(IN);
    if (io){ try { io.unobserve(node); } catch(e){} }
  }

  var io = null;
  function getObserver(){
    if (io) return io;
    if (!("IntersectionObserver" in window)) return null;
    io = new IntersectionObserver(function(entries){
      for (var i=0;i<entries.length;i++){
        var en = entries[i];
        if (en.isIntersecting){
          reveal(en.target);
        }
      }
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    return io;
  }

  // Gather the target elements within a root.
  function collectTargets(root){
    var found = [];
    if (!root || !root.querySelectorAll) return found;

    function push(el){ if (el && found.indexOf(el) === -1) found.push(el); }

    // 1) Featured-collection heading container + generic heading containers.
    var heads = root.querySelectorAll(".hdt-container-heading");
    for (var a=0;a<heads.length;a++) push(heads[a]);

    // 2) h2/h3 that live inside a section wrapper (class contains hdt-section),
    //    but NOT already inside a heading container we grabbed above
    //    (avoid double-revealing the heading and its wrapper).
    var hs = root.querySelectorAll('[class*="hdt-section"] h2, [class*="hdt-section"] h3');
    for (var b=0;b<hs.length;b++){
      var h = hs[b];
      if (h.closest && h.closest(".hdt-container-heading")) continue; // wrapper handles it
      push(h);
    }

    // 3) Rich-text / description blocks. The4 uses .hdt-section-richtext and
    //    rte/description containers; cover common ones tastefully.
    var rich = root.querySelectorAll(
      '[class*="hdt-section-richtext"] .hdt-content, ' +
      '[class*="hdt-section-richtext"] .rte, ' +
      '.hdt-section-text, .hdt-richtext, .hdt-rte'
    );
    for (var c=0;c<rich.length;c++) push(rich[c]);

    // 4) Banners are intentionally NOT collected here — the banner-entrance
    //    feature reveals each .hdt-banner_masonry__item with its own per-item
    //    stagger, which looks better than revealing the wrap as one block.

    return found;
  }

  // Assign a gentle stagger based on document order among newly-found items.
  function process(root){
    var targets = collectTargets(root);
    if (!targets.length) return;

    var seq = 0;
    for (var i=0;i<targets.length;i++){
      var el = targets[i];
      if (shouldSkip(el)) continue;

      if (REDUCE){
        isReducedSafe(el);
        continue;
      }

      el.classList.add(DONE);
      el.classList.add(variantFor(el));
      el.classList.add(ARM); // transient GPU hint, dropped on reveal()

      // Light stagger (capped) so a stack of blocks cascades subtly.
      var delay = Math.min(seq, 5) * 70; // 0..350ms
      el.style.setProperty("--hz-rd", delay + "ms");
      seq++;

      var obs = getObserver();
      if (obs){
        // Safety-net timeout in case IO never fires (e.g. element sits inside
        // a display:none ancestor that is later shown without re-observing,
        // or an engine quirk): force-reveal after 1.2s. reveal() clears the
        // stagger delay so the fallback appears promptly, not 350ms late.
        (function(node){
          node.__hzTo = setTimeout(function(){
            node.style.setProperty("--hz-rd", "0ms");
            reveal(node);
          }, 1200);
        })(el);
        obs.observe(el);
      } else {
        // No IO support -> reveal immediately, never hide.
        el.style.setProperty("--hz-rd", "0ms");
        el.classList.remove(ARM);
        el.classList.add(IN);
      }
    }
  }

  // Debounced batch processor for mutation-driven re-scans. Always scans the
  // whole document (cheap: done/excluded nodes are skipped) so no root is lost.
  var pending = false;
  function scheduleProcess(){
    if (pending) return;
    pending = true;
    var run = function(){
      pending = false;
      try { process(document); } catch(e){}
    };
    if (window.requestAnimationFrame) requestAnimationFrame(run);
    else setTimeout(run, 16);
  }

  function start(){
    try { process(document); } catch(e){}

    // Catch nodes inserted later: section re-render, AJAX filtering,
    // load-more, quick-add modal, etc. — r59: unified dispatcher
    try { window.hzOnAdded(scheduleProcess); } catch(e){}

    // Re-scan on Shopify section load events (theme editor / OS2.0).
    document.addEventListener("shopify:section:load", function(){
      scheduleProcess();
    });
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

/* ===== ken-burns ===== */
(function () {
  "use strict";

  // Idempotency: never wire up twice.
  if (window.__hzKenBurnsInit) return;
  window.__hzKenBurnsInit = true;

  var IMG_SELECTOR = ".hdt-slideshow .hdt-slide_inner img";
  var RUN = "hz-kb-run";
  var MARK = "hz-kb-img";
  var ALT = "hz-kb-alt";
  var PAUSED = "hz-kb-paused";

  /* v7: مراقب ظهور — يوقف زوم Ken Burns عندما يكون الهيرو خارج الشاشة
     (يكمل نفس نمط visibilitychange الموجود أدناه: نفس كلاس الإيقاف hz-kb-paused). */
  var kbIO = null;
  function kbObserve(img) {
    try {
      if (kbIO === null && "IntersectionObserver" in window) {
        kbIO = new IntersectionObserver(function (es) {
          for (var i = 0; i < es.length; i++) {
            es[i].target.__hzKbOff = !es[i].isIntersecting;
          }
          syncVisibility();
        }, { rootMargin: "120px 0px" });
      }
      if (kbIO) kbIO.observe(img);
    } catch (e) {}
  }

  // Respect reduced motion: arm nothing, leave images untouched.
  var rm = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;
  function reduced() {
    return rm ? rm.matches : false;
  }

  // Slide index for alternating pan direction. Re-derived from siblings so
  // it is resilient to re-renders. If the structure differs, falls back to
  // zoom-in (no alternation) which is still valid.
  function isAltImage(img) {
    var inner = img.closest ? img.closest(".hdt-slide_inner") : null;
    if (!inner) return false;
    var slide = inner.parentElement; // the slide element
    var track = slide ? slide.parentElement : null;
    if (!track) return false;
    var slides = track.children;
    var idx = Array.prototype.indexOf.call(slides, slide);
    return idx % 2 === 1; // even slides zoom-in, odd slides zoom-out
  }

  // Begin the animation only once the image is actually painted, so we
  // never animate a blank frame. Single source of truth for "make it run".
  function arm(img) {
    if (!img || img.nodeType !== 1) return;
    if (reduced()) return; // honor reduced motion at arm time
    if (img.classList.contains(RUN)) return;
    img.classList.add(RUN);
    kbObserve(img); /* v7: راقب ظهوره على الشاشة */
    // Honor current visibility state at arm time.
    if (document.hidden || img.__hzKbOff) img.classList.add(PAUSED);
    else img.classList.remove(PAUSED);
  }

  function prepare(img) {
    if (!img || img.nodeType !== 1) return;
    if (img.classList.contains(MARK)) return; // already processed
    img.classList.add(MARK);

    if (isAltImage(img)) img.classList.add(ALT);

    if (reduced()) return; // marked but not armed; re-armed if RM turns off

    var armed = false;
    function go() {
      if (armed) return;
      armed = true;
      arm(img);
    }

    if (img.complete && img.naturalWidth > 0) {
      // Already loaded (cached / SSR-decoded).
      go();
    } else {
      img.addEventListener("load", go, { once: true });
      // On error we still arm: the alt/broken image box just won't move,
      // but nothing gets stuck and the slider stays intact.
      img.addEventListener("error", go, { once: true });
      // Hard fallback so an image can never be left un-armed.
      setTimeout(go, 1200);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll(IMG_SELECTOR);
    for (var i = 0; i < imgs.length; i++) prepare(imgs[i]);
    // If root itself is a slideshow img inserted directly.
    if (root && root.matches && root.matches(IMG_SELECTOR)) {
      prepare(root);
    }
  }

  // Pause/resume with tab visibility (battery friendly, no layout cost).
  // v7: يراعي أيضاً حالة "خارج الشاشة" (__hzKbOff) القادمة من مراقب الظهور أعلاه.
  function syncVisibility() {
    var imgs = document.querySelectorAll("." + RUN);
    for (var i = 0; i < imgs.length; i++) {
      if (document.hidden || imgs[i].__hzKbOff) imgs[i].classList.add(PAUSED);
      else imgs[i].classList.remove(PAUSED);
    }
  }

  function start() {
    scan(document);

    // Catch slides injected/re-rendered later (Shopify section re-render,
    // theme editor, lazy slide build). r59: unified dispatcher (already
    // rAF-batched there — private queue/flush deleted).
    window.hzOnAdded(scan);

    document.addEventListener("visibilitychange", syncVisibility, {
      passive: true
    });

    // Runtime reduced-motion toggling. When enabled, stop all motion
    // (remove RUN/PAUSED); when disabled, (re)arm marked images and scan
    // for any that arrived while RM was on. Re-arming is done directly via
    // arm() rather than prepare(), because prepare() short-circuits on the
    // MARK class and would otherwise never resume already-seen images.
    if (rm) {
      var onRM = function () {
        if (reduced()) {
          var running = document.querySelectorAll("." + MARK);
          for (var k = 0; k < running.length; k++) {
            running[k].classList.remove(RUN);
            running[k].classList.remove(PAUSED);
          }
        } else {
          scan(document); // pick up any imgs inserted while RM was on
          var marked = document.querySelectorAll("." + MARK);
          for (var m = 0; m < marked.length; m++) {
            var el = marked[m];
            // Only arm those that are actually paintable; broken/blank
            // images simply stay still (no stuck-hidden state possible).
            if (el.complete ? el.naturalWidth > 0 : true) arm(el);
          }
        }
      };
      if (rm.addEventListener) rm.addEventListener("change", onRM);
      else if (rm.addListener) rm.addListener(onRM);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();

/* ===== banner-entrance ===== */
(function(){
  "use strict";
  if (window.__hzBannerInit) return;          /* guard double-injection */
  window.__hzBannerInit = true;

  var REDUCE = false;
  try {
    REDUCE = window.matchMedia &&
             window.matchMedia("(prefers-reduced-motion:reduce)").matches;
  } catch(e){}

  var supportsIO = "IntersectionObserver" in window;
  var io = null;

  function reveal(item){
    if (!item || item.classList.contains("hz-bn-in")) return;
    item.classList.add("hz-bn-in");
  }

  if (supportsIO && !REDUCE){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          reveal(en.target);
          io.unobserve(en.target);
        }
      });
    }, { rootMargin:"0px 0px -8% 0px", threshold:0.04 });
  }

  /* Resolve the cell for an image deterministically: the direct child of the
     grid (the visual masonry track) that contains this image. This avoids the
     fragile closest("a")/bounded-climb heuristic, which could either under-climb
     (leaving a mid-level wrapper as the cell) or over-climb to an <a> wrapping
     the whole grid (collapsing every image into one cell). Returns null if the
     image isn't actually inside the grid. */
  function resolveCell(img, grid){
    var node = img;
    while (node && node.parentElement && node.parentElement !== grid){
      node = node.parentElement;
    }
    /* node is now a direct child of grid (its parent === grid), or we ran out
       of ancestors without reaching grid (img not under grid). */
    if (node && node.parentElement === grid) return node;
    return null;
  }

  /* Mark each banner cell inside a wrap: tag it with the feature classes,
     set its stagger delay, observe it, and arm a per-item safety-net timeout. */
  function processWrap(wrap){
    if (!wrap || wrap.__hzBnDone) return;
    wrap.__hzBnDone = true;

    var grid = wrap.querySelector(".hdt-banner_masonry") || wrap;
    var imgs = grid.querySelectorAll("img");
    var seen = [];

    for (var i=0;i<imgs.length;i++){
      var cell = resolveCell(imgs[i], grid);
      if (!cell) continue;
      if (cell === grid || cell === wrap) continue;
      if (cell.__hzBnItem) continue;      /* dedupe: multiple imgs per cell */
      cell.__hzBnItem = true;
      seen.push(cell);
    }

    seen.forEach(function(cell, idx){
      cell.classList.add("hz-banner-item", "hz-bn-overlay");

      if (REDUCE || !io){
        /* no entrance animation: show immediately */
        reveal(cell);
        return;
      }

      /* per-item stagger, capped so a long grid doesn't drag */
      var delay = Math.min(idx * 90, 540);
      cell.style.setProperty("--hz-bn-delay", delay + "ms");
      io.observe(cell);

      /* Safety net: if the observer never fires (already on-screen edge cases,
         layout quirks, cached images), force-reveal after a timeout so nothing
         stays invisible. */
      setTimeout(function(){ reveal(cell); }, 1800 + delay);
    });
  }

  function scan(root){
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = scope.querySelectorAll(".hdt-banner_wrap");
    for (var i=0;i<wraps.length;i++) processWrap(wraps[i]);
    /* also handle case where root itself is a wrap */
    if (root && root.classList && root.classList.contains("hdt-banner_wrap")){
      processWrap(root);
    }
  }

  function init(){ scan(document); }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init, { once:true });
  } else {
    init();
  }

  /* Re-arm a wrap that the theme editor / AJAX re-rendered. Because the theme
     may reuse the same DOM nodes, we must clear BOTH the per-wrap flag and any
     stale per-cell flags inside it; otherwise reused cells would be skipped and
     never re-tagged (could leave them stuck at opacity:0). */
  function rearmWrap(wrap){
    if (!wrap) return;
    wrap.__hzBnDone = false;
    var prev = wrap.querySelectorAll(".hz-banner-item");
    for (var i=0;i<prev.length;i++){ prev[i].__hzBnItem = false; }
    processWrap(wrap);
  }

  /* Catch sections re-rendered by the theme editor / AJAX. r59: unified dispatcher. */
  window.hzOnAdded(function(n){
    if (n.classList && n.classList.contains("hdt-banner_wrap")){
      rearmWrap(n);
    } else if (n.querySelectorAll){
      var inner = n.querySelectorAll(".hdt-banner_wrap");
      for (var k=0;k<inner.length;k++) rearmWrap(inner[k]);
    }
  });
})();

/* ===== header-scroll ===== */
(function(){
  "use strict";
  // Idempotency guard — never run twice even if injected/duplicated.
  if (window.__hzScrolledHeaderInit) return;
  window.__hzScrolledHeaderInit = true;

  var THRESHOLD = 40;
  var root = document.documentElement; // <html>
  var ticking = false;
  var lastState = null;

  function apply(){
    ticking = false;
    var scrolled = (window.pageYOffset || root.scrollTop || 0) > THRESHOLD;
    if (scrolled === lastState) return; // avoid redundant class writes
    lastState = scrolled;
    if (scrolled) root.classList.add("hz-scrolled");
    else root.classList.remove("hz-scrolled");
  }

  function onScroll(){
    if (!ticking){
      ticking = true;
      window.requestAnimationFrame(apply);
    }
  }

  function start(){
    // Passive listener + rAF throttle.
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    apply(); // set correct initial state (e.g. reload mid-page)
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  // NOTE: no MutationObserver. The scroll-state class lives on <html>, which
  // is never re-rendered by Shopify section editor / AJAX / quick-add / cart.
  // When the theme re-injects the header subtree, our CSS still matches it
  // immediately because the .hz-scrolled / .is-sticky state lives on an
  // ancestor (<html>) or is re-applied by the theme itself. A body-wide
  // MutationObserver would fire constantly during slider autoplay, AJAX
  // collection filtering, and drawer open/close — each callback would force a
  // layout read (window.pageYOffset) on a hot path and defeat the rAF throttle
  // for zero behavioral benefit. The scroll + resize listeners fully cover it.
})();

/* ===== marquee ===== */
(function(){
  "use strict";

  /* ===== EDIT HERE ===== */
  var PHRASES = ["توصيل لكل الكويت","١٠ فروع في الكويت","تسوّقي الآن","جودة وأناقة"];
  var SEPARATOR = "•";          // separator glyph between phrases
  var SPEED_PX_PER_SEC = 30;    // marquee speed (higher = faster). Same speed on every screen size.
  /* ===================== */

  var MARQUEE_ID = "hz-marquee";
  var REDUCE = false;
  try { REDUCE = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch(e){}

  /* Append ONE pass of all phrases (item + separator) into a group. */
  function makePass(group, ariaHidden){
    for (var i = 0; i < PHRASES.length; i++){
      var item = document.createElement("span");
      item.className = "hz-mq-item";
      item.textContent = PHRASES[i];
      if (ariaHidden) item.setAttribute("aria-hidden", "true");
      group.appendChild(item);

      var sep = document.createElement("span");
      sep.className = "hz-mq-sep";
      sep.setAttribute("aria-hidden", "true");
      sep.textContent = SEPARATOR;
      group.appendChild(sep);
    }
  }

  function makeGroup(ariaHidden){
    var g = document.createElement("div");
    g.className = "hz-mq-group";
    if (ariaHidden) g.setAttribute("aria-hidden", "true");
    makePass(g, ariaHidden);
    return g;
  }

  function viewportW(){
    return Math.max(window.innerWidth || 0, document.documentElement.clientWidth || 0);
  }

  /* Pad both groups (equally, so they stay identical) until ONE group is at
     least as wide as the viewport. With two identical groups and a -50% shift,
     a group >= viewport guarantees the strip always fills the bar — no empty
     gap behind the text on wide desktop screens. Then set a width-proportional
     duration so the speed stays constant regardless of how wide it ended up. */
  function pad(track, g1, g2){
    if (REDUCE) return;
    /* r75 (2026-09-23): PageSpeed سجّل 265ms "forced reflow" هون على الديسكتوب — كل قراءة offsetWidth بعد إضافة
       بتجبر المتصفح يعيد تخطيط الصفحة كلها (~4,600 عنصر) وهي لسا عم تتحمّل. صار قياس واحد: نقرأ عرض التمريرة
       الأولى مرّة، نحسب كم تمريرة ناقصة حتى تصير المجموعة ≥ عرض الشاشة (نفس الضمانة القديمة، التمريرات متطابقة)،
       نضيفها دفعة وحدة، ونحسب المدّة حسابيًا بدل قياس ثانٍ. */
    var vw = viewportW();
    var w0 = g1.offsetWidth;                                   /* القياس الوحيد */
    if (!(w0 > 0)) return;
    /* onResize بتستدعي pad() من جديد على مجموعة ممتلئة أصلًا — فعرض التمريرة الواحدة = العرض الحالي ÷ عدد التمريرات الموجودة */
    var cur = Math.max(1, Math.round(g1.children.length / (PHRASES.length * 2)));
    var per = w0 / cur;
    var need = Math.max(0, Math.min(24, Math.ceil(vw / per) - cur));
    for (var i = 0; i < need; i++){
      makePass(g1, false);
      makePass(g2, true);
    }
    var dur = Math.max(8, Math.round((per * (cur + need)) / SPEED_PX_PER_SEC));
    track.style.setProperty("--hz-mq-dur", dur + "s");
  }

  function build(){
    /* r65: القشرة تُطبع من السيرفر (بعد <body> مباشرة) لحجز الارتفاع من أول
       رسمة — لا قفزة عند التنقّل. هنا نكتفي بتعبئتها بالنصوص. */
    var bar = document.getElementById(MARQUEE_ID);
    if (bar && bar.querySelector(".hz-mq-item")) return;   // idempotent
    if (!document.body) return;

    var isRTL = (document.documentElement.getAttribute("dir") === "rtl") ||
                (document.body.getAttribute("dir") === "rtl");

    if (!bar){
      /* فولباك: لو غابت القشرة لأي سبب ننشئها كما قبل r65 */
      bar = document.createElement("div");
      bar.id = MARQUEE_ID;
      bar.setAttribute("aria-label", "إعلانات");
      if (document.body.firstChild) document.body.insertBefore(bar, document.body.firstChild);
      else document.body.appendChild(bar);
    }
    bar.setAttribute("data-hz-dir", isRTL ? "rtl" : "ltr");

    var viewport = bar.querySelector(".hz-mq-viewport");
    if (!viewport){
      viewport = document.createElement("div");
      viewport.className = "hz-mq-viewport";
      bar.appendChild(viewport);
    }
    var track = viewport.querySelector(".hz-mq-track");
    if (!track){
      track = document.createElement("div");
      track.className = "hz-mq-track";
      viewport.appendChild(track);
    }

    var g1 = makeGroup(false);     // announced copy
    var g2 = makeGroup(true);      // duplicate for the seamless loop (a11y-hidden)
    track.appendChild(g1);
    track.appendChild(g2);

    pad(track, g1, g2);   // measure + fill so there's no gap (must be after insert)

    /* v7: أوقفي حركة الشريط عندما يكون خارج الشاشة أو التبويب مخفيّاً (توفير معالجة وبطارية).
       نستخدم style مباشراً حتى لا نتعارض مع إيقاف الـ hover الموجود في CSS. */
    try{
      if (!REDUCE){
        var mqOff = false;
        var mqSync = function(){
          var t = bar.querySelector(".hz-mq-track");
          if (!t) return;
          t.style.animationPlayState = (mqOff || document.hidden) ? "paused" : "";
        };
        if ("IntersectionObserver" in window){
          new IntersectionObserver(function(es){
            for (var i = 0; i < es.length; i++){ mqOff = !es[i].isIntersecting; }
            mqSync();
          }, { rootMargin: "80px 0px" }).observe(bar);
        }
        document.addEventListener("visibilitychange", mqSync, { passive: true });
      }
    }catch(e){}

    // Safety net: never let the strip collapse to zero height.
    setTimeout(function(){
      var el = document.getElementById(MARQUEE_ID);
      if (el && el.offsetHeight < 4){
        el.style.height = "36px"; el.style.display = "flex"; el.style.alignItems = "center";
      }
    }, 1200);
  }

  /* Re-pad if the viewport grows (e.g. rotate / window resize) so a wider
     screen never reveals a gap. Debounced. */
  var rT;
  function onResize(){
    if (REDUCE) return;
    clearTimeout(rT);
    rT = setTimeout(function(){
      var bar = document.getElementById(MARQUEE_ID); if (!bar) return;
      var track = bar.querySelector(".hz-mq-track"); if (!track) return;
      var groups = track.querySelectorAll(".hz-mq-group"); if (groups.length < 2) return;
      pad(track, groups[0], groups[1]);
    }, 250);
  }
  window.addEventListener("resize", onResize, { passive: true });

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", build, { once:true });
  } else {
    build();
  }

  // Rebuild if the strip ever disappears (section re-render / AJAX body swap).
  try {
    var obs = new MutationObserver(function(){
      if (document.body && !document.getElementById(MARQUEE_ID)) build();
    });
    if (document.body){ obs.observe(document.body, { childList:true }); }
    else { document.addEventListener("DOMContentLoaded", function(){ obs.observe(document.body, { childList:true }); }, { once:true }); }
  } catch(e){}
})();

/* ===== atc-success ===== */
(function(){
  "use strict";
  if (window.__hzAtcInit) return;        /* idempotent: never patch / bind twice */
  window.__hzAtcInit = true;

  var SUCCESS_CLASS = "hz-atc-success";
  var CHECK_CLASS   = "hz-atc-check";
  var DURATION      = 1200;              /* ms the success state stays */
  var BTN_SEL       = "button.hdt-product-form__submit";

  function isVisible(el){
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    var s = window.getComputedStyle(el);
    if (s.display === "none" || s.visibility === "hidden") return false;
    return true;
  }

  function ensureCheck(btn){
    var span = btn.querySelector("." + CHECK_CLASS);
    if (!span){
      span = document.createElement("span");
      span.className = CHECK_CLASS;
      span.setAttribute("aria-hidden", "true");
      btn.appendChild(span);
    }
    return span;
  }

  function celebrate(btn){
    if (!isVisible(btn)) return;
    ensureCheck(btn);
    /* restart animation cleanly if it's already mid-flight */
    btn.classList.remove(SUCCESS_CLASS);
    /* force reflow so re-adding the class restarts the keyframes */
    void btn.offsetWidth;
    btn.classList.add(SUCCESS_CLASS);

    if (btn.__hzAtcTimer) clearTimeout(btn.__hzAtcTimer);
    btn.__hzAtcTimer = setTimeout(function(){
      btn.classList.remove(SUCCESS_CLASS);
      btn.__hzAtcTimer = null;
    }, DURATION + 60);
  }

  function fireSuccess(){
    /* Trigger on every currently-visible add button (usually one on a PDP). */
    var btns = document.querySelectorAll(BTN_SEL);
    for (var i = 0; i < btns.length; i++){
      if (isVisible(btns[i])) celebrate(btns[i]);
    }
  }

  /* ---- hz cart-drawer rescue (r63) ----------------------------------
     Kalles' post-add drawer render throws when the add response's
     `sections` map is null (quick-view / إضافة سريعة context) → the
     drawer never opens and the count badge stays stale even though the
     item WAS added. 400ms after a successful add, if the drawer didn't
     open by itself, re-render it from its live section-id and open it.
     No-ops when the vendor path worked (e.g. standalone PDP). */
  function hzDrawerRescue(){
    try {
      var dlg = document.getElementById("CartDrawer");
      if (dlg && dlg.open) return;                    /* vendor path worked */
      var drawer = document.querySelector("hdt-cart-drawer");
      if (!drawer) return;
      var sid = drawer.getAttribute("section-id");    /* live dynamic id — never hardcoded */
      if (!sid) return;
      fetch("/?section_id=" + encodeURIComponent(sid))
        .then(function(r){ return r.ok ? r.text() : null; })
        .then(function(html){
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.getElementById("shopify-section-" + sid);
          var freshDrawer = fresh && fresh.querySelector("hdt-cart-drawer");
          var live = document.getElementById("shopify-section-" + sid);
          if (!fresh || !freshDrawer || !live) return;
          live.innerHTML = fresh.innerHTML;
          var count = freshDrawer.getAttribute("data-count");
          if (count != null){
            var badges = document.querySelectorAll("hdt-cart-count");
            for (var i = 0; i < badges.length; i++) badges[i].textContent = count;
          }
          var total = freshDrawer.getAttribute("data-total-price");
          if (total){
            var totals = document.querySelectorAll("hdt-cart-total");
            for (var j = 0; j < totals.length; j++){
              var m = totals[j].querySelector(".hdt-money");
              if (m) m.innerHTML = total;
            }
          }
          var nd = document.getElementById("CartDrawer");
          if (nd && typeof nd.showModal === "function" && !nd.open) nd.showModal();
        })
        .catch(function(){ /* never throw */ });
    } catch(e){ /* never throw */ }
  }

  function fireSuccessThenRescue(){
    fireSuccess();
    setTimeout(hzDrawerRescue, 400);
  }

  function isCartAddUrl(url){
    if (url == null) return false;
    try { url = String(url); } catch(e){ return false; }
    /* Shopify cart-add endpoint, incl. /cart/add.js and locale-prefixed paths.
       Anchor to a path segment to avoid matching e.g. /cart/address-* . */
    return /\/cart\/add(\.js)?($|\?|#|\/)/.test(url);
  }

  /* ---- Patch fetch ---- */
  if (typeof window.fetch === "function"){
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (input && typeof input === "object" && "url" in input) ? input.url : input;
      var watched = isCartAddUrl(url);
      var p = _fetch.apply(this, arguments);
      if (watched && p && typeof p.then === "function"){
        p.then(function(res){
          if (res && res.ok) fireSuccessThenRescue();
        }).catch(function(){ /* ignore */ });
      }
      return p;
    };
  }

  /* ---- Patch XMLHttpRequest ---- */
  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype){
    var XP = window.XMLHttpRequest.prototype;
    var _open = XP.open;
    var _send = XP.send;
    XP.open = function(method, url){
      try { this.__hzAtcWatched = isCartAddUrl(url); } catch(e){ this.__hzAtcWatched = false; }
      return _open.apply(this, arguments);
    };
    XP.send = function(){
      if (this.__hzAtcWatched){
        var xhr = this;
        xhr.addEventListener("load", function(){
          if (xhr.status >= 200 && xhr.status < 300) fireSuccessThenRescue();
        });
      }
      return _send.apply(this, arguments);
    };
  }
})();

/* ===== img-fadein ===== */
(function(){
  "use strict";
  if (window.__hzImgFadeInit) return;        // double-injection guard
  window.__hzImgFadeInit = true;

  // NOTE: product-card images are intentionally EXCLUDED. Cards already fade in
  // via the card-reveal system, and they rely on their own
  // `transition: transform .6s` for the smooth hover zoom — adding .hz-img here
  // would override that transition (opacity only) and make the hover jump.
  var SELECTOR = [
    ".hdt-slideshow img",
    ".hdt-banner_wrap img"
  ].join(",");

  var SAFETY_MS = 3000;
  var reduce = window.matchMedia &&
               window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function reveal(img){
    if (!img || img.classList.contains("hz-img-in")) return;
    img.classList.add("hz-img-in");
  }

  function process(img){
    // Must be an <img>, not already handled.
    if (!img || img.tagName !== "IMG") return;
    if (img.classList.contains("hz-img")) return;   // idempotent

    img.classList.add("hz-img");

    // Reduced motion: skip the animation entirely, reveal now.
    if (reduce){ reveal(img); return; }

    // Already loaded (cached / decoded before we got here): reveal immediately.
    if (img.complete && img.naturalWidth > 0){
      reveal(img);
      return;
    }

    var done = false;
    function fire(){
      if (done) return;
      done = true;
      img.removeEventListener("load", fire);
      img.removeEventListener("error", fire);
      reveal(img);
    }

    // Reveal on load AND on error (broken image must never stay invisible).
    img.addEventListener("load", fire);
    img.addEventListener("error", fire);

    // Safety net: force-reveal so an image can never get stuck hidden
    // (e.g. a load event we missed in the gap between complete-check and bind).
    setTimeout(fire, SAFETY_MS);

    // Re-check after binding in case it completed during the listener attach.
    if (img.complete && img.naturalWidth > 0) fire();
  }

  function scan(root){
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) process(imgs[i]);
    // If root itself is a targeted img (e.g. inserted directly).
    if (root.matches && root.matches(SELECTOR)) process(root);
  }

  function init(){
    scan(document);
    // r59: unified dispatcher (childList-only there too — .hz-img classes
    // never re-trigger it).
    window.hzOnAdded(scan);
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ===== clickable ===== */
(function(){
  "use strict";
  if (window.__hzClickableInit) return;        /* idempotent */
  window.__hzClickableInit = true;

  /* Blocks whose whole area should follow their primary link. */
  var GROUPS = [
    ".hdt-slideshow .hdt-slide_inner",
    ".hdt-banner_masonry__item"
  ];

  /* The theme overlays a full-tile link <a class="hdt-full-width-link"> on these
     blocks, but leaves it WITHOUT an href when the section's link field is empty.
     That empty overlay swallows clicks (so nothing happens). The real destination
     lives on the visible CTA link (e.g. "تسوّقي" / "اكتشفي الآن"). */

  function primaryHref(block){
    var links = block.querySelectorAll("a[href]");
    for (var i=0;i<links.length;i++){
      var a = links[i];
      if (a.classList.contains("hdt-full-width-link")) continue; /* skip the overlay */
      var h = a.getAttribute("href");
      if (h && h !== "#" && h.indexOf("javascript:") !== 0) return h;
    }
    return null;
  }

  function makeClickable(block){
    if (!block || block.__hzClickable) return;
    var href = primaryHref(block);
    if (!href) return;                       /* no destination → leave it alone */
    block.__hzClickable = true;
    block.classList.add("hz-clickable");

    /* PRIMARY FIX: give the theme's empty full-width overlay link the real href,
       so the whole tile becomes natively clickable (and keyboard-accessible). */
    var full = block.querySelector("a.hdt-full-width-link");
    if (full && !((full.getAttribute("href") || "").trim())){
      full.setAttribute("href", href);
    }

    /* FALLBACK: for blocks without that overlay, handle the click ourselves. */
    block.addEventListener("click", function(e){
      var t = e.target;
      /* respect real controls */
      if (t.closest && t.closest("button,input,select,textarea,label,[role='button']")) return;
      /* respect real links (let them navigate natively); ignore href-less <a> */
      var lnk = t.closest && t.closest("a");
      if (lnk){
        var h = lnk.getAttribute("href");
        if (h && h !== "#" && h.indexOf("javascript:") !== 0) return;
      }
      /* don't hijack a text selection drag */
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;

      if (e.metaKey || e.ctrlKey || e.button === 1){ window.open(href, "_blank"); }
      else { window.location.href = href; }
    });
  }

  function scan(root){
    var scope = root && root.querySelectorAll ? root : document;
    for (var g=0; g<GROUPS.length; g++){
      var blocks = scope.querySelectorAll(GROUPS[g]);
      for (var i=0; i<blocks.length; i++) makeClickable(blocks[i]);
      if (root && root.matches && root.matches(GROUPS[g])) makeClickable(root);
    }
  }

  function init(){
    scan(document);
    /* r59: unified dispatcher */
    window.hzOnAdded(scan);
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* v7: أُزيل باتش email-fix — تصحيح البريد صار من مصدره في إعدادات السكشن مباشرة */
  

/* ═══ hz-dialog-open (r76، 2026-09-23) ═══
   بديل body:has(dialog[open]) بـhz-v7.css §٣٩: صنف على <html> يشتغل لمّا يفتح أحد الحوارات الثلاثة (درج السلة/القائمة،
   العرض السريع، الإضافة السريعة) ويطفى بإغلاقها. مراقب سمات فقط (attributeFilter: open) — رخيص، ما بيتفعّل مع تغييرات المحتوى. */
(function(){
  "use strict";
  var SEL = "dialog.hdt-dialog-drawer[open], dialog#hdt-quick-view-modal[open], dialog#hdt-quick-add-modal[open]";
  var root = document.documentElement, pending = false;
  function sync(){
    pending = false;
    var open = !!document.querySelector(SEL);
    if (open !== root.classList.contains("hz-dialog-open")) root.classList.toggle("hz-dialog-open", open);
  }
  function arm(){
    try {
      new MutationObserver(function(){
        if (pending) return;
        pending = true;
        if (window.requestAnimationFrame) window.requestAnimationFrame(sync);
        setTimeout(function(){ if (pending) sync(); }, 120);   /* شبكة أمان: التبويب المخفي ما بيشغّل rAF */
      })
        .observe(root, { attributes: true, attributeFilter: ["open"], subtree: true });
    } catch(e){}
    sync();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm, { once: true }); else arm();
})();
